import React from 'react';
import { ColumnConfig } from './Table';

export interface TableHeaderProps {
  value: ColumnConfig;
  setAuftraegeSortBy?: (attributeName: string, sortingCount: number) => void;
  sortingCount?: number;
  sortBy?: string;
}

const TableHeader = ({
  value,
  setAuftraegeSortBy,
  sortingCount,
  sortBy,
}: TableHeaderProps) => {
  const getIconClassName = () => {
    switch (sortingCount) {
      // standard
      case 0:
        return 'fas fa-sort';
      // aufsteigend
      case 1:
        return 'fas fa-sort-up';
      // absteigend
      case 2:
        return 'fas fa-sort-down';
      default:
        return 'fas fa-sort';
    }
  };

  const onClick = () => {
    if (setAuftraegeSortBy && sortingCount !== undefined) {
      if (sortBy === value.attributName) {
        setAuftraegeSortBy(value.attributName, sortingCount + 1);
      } else {
        setAuftraegeSortBy(value.attributName, 1);
      }
    }
  };

  return (
    <th style={{ width: value.width }}>
      {value.columnName}
      {setAuftraegeSortBy !== undefined && (
        <i
          className={
            sortBy === value.attributName ? getIconClassName() : 'fas fa-sort'
          }
          onClick={() => onClick()}
        />
      )}
    </th>
  );
};

export default TableHeader;
